
(function() {
  var result = { translations: { "pl": { "i18n": { "duration": { "seconds": "{{ seconds }} s", "minutes": "{{ minutes }}min", "hours": "{{ hours }} h", "hoursAndMinutes": "{{ hours }} h {{ minutes }} min", "days": "{{ days }} dni", "shortForm": { "seconds": "{{ seconds }} s", "minutes": "{{ minutes }} min", "hours": "{{ hours }} godz", "days": "{{ days }} dn.", "hoursAndMinutes": "{{ hours }} godz. {{ minutes }} min" } }, "dateTime": { "quarterAndYear": "Q{{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{amountNumberValue}} {{currencyCode}}", "phoneNumberWithExtension": "{{phoneNumber}}, rozsz. {{extension}}" } } } } };
  result.translationsLoaded = {
  "I18n": {
    "pl": "static-7.1044"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.1044",
    "ar-eg": "static-7.1044",
    "bg": "static-7.1044",
    "bn": "static-7.1044",
    "ca-es": "static-7.1044",
    "cs": "static-7.1044",
    "da": "static-7.1044",
    "de": "static-7.1044",
    "el": "static-7.1044",
    "en-gb": "static-7.1044",
    "en": "static-7.1044",
    "es-mx": "static-7.1044",
    "es": "static-7.1044",
    "et": "static-7.1044",
    "fi": "static-7.1044",
    "fr-ca": "static-7.1044",
    "fr": "static-7.1044",
    "he-il": "static-7.1044",
    "hi": "static-7.1044",
    "hr": "static-7.1044",
    "hu": "static-7.1044",
    "id": "static-7.1044",
    "it": "static-7.1044",
    "ja": "static-7.1044",
    "ko": "static-7.1044",
    "lt": "static-7.1044",
    "ms": "static-7.1044",
    "nl": "static-7.1044",
    "no": "static-7.1044",
    "pl": "static-7.1044",
    "pt-br": "static-7.1044",
    "pt-pt": "static-7.1044",
    "ro": "static-7.1044",
    "ru": "static-7.1044",
    "sk": "static-7.1044",
    "sl": "static-7.1044",
    "sv": "static-7.1044",
    "th": "static-7.1044",
    "tl": "static-7.1044",
    "tr": "static-7.1044",
    "uk": "static-7.1044",
    "vi": "static-7.1044",
    "x-pseudo": "static-7.1044",
    "zh-cn": "static-7.1044",
    "zh-hk": "static-7.1044",
    "zh-tw": "static-7.1044"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:pl', {version: 'static-7.1044'}); }
})();


